import { FC, ReactNode } from "react";
import styles from "../../css/Generics.module.css";
import { useDarkModeContext } from "@/hooks/contextHooks/useDarkModeContext";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";

type Props = {
  children: ReactNode;
  action: VoidFunction;
};

export const Btn: FC<Props> = ({ children, action }) => {
  const { isDarkMode, colors } = useAppColors();
  return (
    <button
      className={styles.btn}
      onClick={action}
      style={{ backgroundColor: isDarkMode ? colors.secondary : colors.brand }}
    >
      {children}
    </button>
  );
};
